import { LazyLoad } from 'app/utils';

export const UserListPage = LazyLoad(
  () => import('./index'),
  (module) => module.UserListPage,
);
